<!-- ADD MODE -->
<c-row *ngIf="Add">
  <c-col xs="12">
    <c-card class="mb-4">
      <c-card-body>
        <button (click)="listItems()" class="btn btn-secondary mb-3">Back to List</button>
        <form [formGroup]="form" (ngSubmit)="submitForm()">
          <c-row class="mb-3">
            <c-col xs="12" md="6">
              <label cLabel for="modelName">Model Name</label>
              <input id="modelName" cFormControl formControlName="modelName" autocomplete="off" />
            </c-col>
            <c-col xs="12" md="6">
              <label cLabel for="url">URL</label>
              <input id="url" cFormControl formControlName="url" autocomplete="off" />
            </c-col>
          </c-row>

          <c-row class="mb-3">
            <c-col xs="12" md="6">
              <label cLabel for="title">Title</label>
              <input id="title" cFormControl formControlName="title" autocomplete="off" />
            </c-col>
              <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="content">Content</label>
                            <ckeditor name="myckeditor" #ckeditor required [config]="ckeConfig" debounce="500"
                                formControlName="description" (change)="onInputChange()">
                            </ckeditor>
                            <span class="required" *ngIf="serverErrors?.content">{{
                                serverErrors.content
                                }}</span>
                        </c-col>
          </c-row>
          <c-row class="mb-3">
            <c-col xs="12" md="6">
              <label cLabel for="thumbnail">Thumbnail</label>
              <input type="file" id="thumbnail" (change)="uploadThumbnail($event)" />
              <div *ngIf="previewThumbnail" class="mt-2">
                <img [src]="previewThumbnail" alt="Thumbnail preview" width="120" />
              </div>
            </c-col>
          </c-row>

          <c-row class="mb-3">
            <c-col xs="12" md="6">
              <label cLabel for="status">Status</label>
              <select id="status" cFormControl formControlName="status">
                <option value="active">Active</option>
                <option value="deactive">Deactive</option>
              </select>
            </c-col>
          </c-row>

          <button cButton type="submit" class="btn btn-primary">Submit</button>
        </form>
      </c-card-body>
    </c-card>
  </c-col>
</c-row>

<!-- LIST MODE -->
<c-row *ngIf="!Add && !Edit">
  <c-col xs="12">
    <c-card>
      <c-card-header>
        <strong>Learn Pages</strong>
        <button class="btn btn-success float-end" (click)="addItem()">Add New</button>
      </c-card-header>
      <c-card-body>
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Model Name</th>
              <th>url</th>
              <th>Title</th>
              <th>description</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of learnItems">
              <td>{{ item.modelName }}</td>
              <td>{{ item.url }}</td>
              <td>{{ item.title }}</td>
              <td>{{ item.description }}</td>
              <td>{{ item.status }}</td>
              <td>
                <button (click)="editItem(item)" class="btn btn-sm btn-warning me-1">Edit</button>
                <button (click)="deleteItem(item._id)" class="btn btn-sm btn-danger">Delete</button>
              </td>
            </tr>
          </tbody>
        </table>
      </c-card-body>
    </c-card>
  </c-col>
</c-row>

<!-- EDIT MODE -->
<c-row *ngIf="Edit">
  <c-col xs="12">
    <c-card class="mb-4">
      <c-card-body>
        <button (click)="listItems()" class="btn btn-secondary mb-3">Back to List</button>
        <form [formGroup]="form" (ngSubmit)="updateForm()">
          <c-row class="mb-3">
            <c-col xs="12" md="6">
              <label cLabel for="modelName">Model Name</label>
              <input id="modelName" cFormControl formControlName="modelName" autocomplete="off" />
            </c-col>
            <c-col xs="12" md="6">
              <label cLabel for="url">URL</label>
              <input id="url" cFormControl formControlName="url" autocomplete="off" />
            </c-col>
          </c-row>

          <c-row class="mb-3">
            <c-col xs="12" md="6">
              <label cLabel for="title">Title</label>
              <input id="title" cFormControl formControlName="title" autocomplete="off" />
            </c-col>
                 <c-col xs="12" md="6" class="mb-3 mb-md-0">
                            <label cLabel for="content">Content</label>
                            <ckeditor name="myckeditor" #ckeditor required [config]="ckeConfig" debounce="500"
                                formControlName="description" (change)="onInputChange()">
                            </ckeditor>
                            <span class="required" *ngIf="serverErrors?.content">{{
                                serverErrors.content
                                }}</span>
                        </c-col>
          </c-row>

          <c-row class="mb-3">
            <c-col xs="12" md="6">
              <label cLabel for="thumbnail">Thumbnail</label>
              <input type="file" id="thumbnail" (change)="uploadThumbnail($event)" />
              <div *ngIf="previewThumbnail" class="mt-2">
                <img [src]="previewThumbnail" alt="Thumbnail preview" width="120" />
              </div>
            </c-col>
          </c-row>

          <c-row class="mb-3">
            <c-col xs="12" md="6">
              <label cLabel for="status">Status</label>
              <select id="status" cFormControl formControlName="status">
                <option value="active">Active</option>
                <option value="deactive">Deactive</option>
              </select>
            </c-col>
          </c-row>

          <button cButton type="submit" class="btn btn-primary">Update</button>
        </form>
      </c-card-body>
    </c-card>
  </c-col>
</c-row>
